// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-widget-text[data-v-11223952] {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.text-widget[data-v-11223952] {\n  position: absolute;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
